exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cssload-aim[data-v-025d67da]{position:fixed;z-index:1500;left:calc(100% - 57px);top:66px;border-radius:20px;background-color:transparent;border-width:15px;border-style:double;border-color:transparent #428bca;-webkit-animation:cssload-anim-data-v-025d67da .7s linear infinite;animation:cssload-anim-data-v-025d67da .7s linear infinite}@media screen and (max-width:560px){.cssload-aim[data-v-025d67da]{top:106px}}@-webkit-keyframes cssload-anim-data-v-025d67da{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes cssload-anim-data-v-025d67da{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-025d67da","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/preloader/preloader.vue
// module id = ODPw
// module chunks = 1